import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { Button } from '@shared/components';

@Component({
  selector: 'app-demo-hero',
  imports: [Button, NgOptimizedImage],
  templateUrl: './demo-hero.html',
  styleUrl: './demo-hero.scss',
})
export class DemoHero {
  readonly appUrl = environment.appUrl;
}
